import { Input, Button, Space } from 'antd';
import { SearchOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import _ from 'lodash';

const PaymentMethods = ['Paypal', 'Cash', 'Bank Transfer', 'Credit Card', 'Paypro'];

export const OrderTableConfig = (handleSearch, handleReset, responsibilities) => {
  const getColumnSearchProps = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
    };
  };
  return [
    {
      title: 'Order ID',
      dataIndex: 'order_id',
      key: 'order_id',
      width: '2%',
    },
    {
      title: 'Client Name',
      dataIndex: 'client_name',
      key: 'client_name',
      width: '3%',
    },
    {
      title: 'Product',
      dataIndex: 'productname',
      key: 'productname',
      width: '3%',
    },
    {
      title: 'Payment Method',
      dataIndex: 'payment_method_id',
      key: 'name',
      width: '3%',
      render: (payment_method_id) => PaymentMethods[parseInt(payment_method_id)],
    },

    {
      title: 'Status',
      dataIndex: 'order_status',
      key: 'order_status',
      width: '3%',
      // render: (order_status) => {
      //   return <Tag color={order_status = 'green' }>{order_status = 'Paid'}</Tag>;
      // },
    },
    {
      title: 'Discount',
      dataIndex: 'discount',
      key: 'discount',
      width: '3%',
    },
    {
      title: 'Total Price',
      dataIndex: 'total_price',
      key: 'total_price',
      width: '3%',
    },

    {
      title: 'Credit',
      dataIndex: 'remaining_amount',
      key: 'remaining_amount',
      width: '3%',
    },
    {
      title: 'Order Date',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '3%',
      render: (created_at) => {
        return <div>{created_at ? created_at.split('T')[0] : 'N/A'}</div>;
      },
    },
    // {
    //   title: 'Comments',
    //   dataIndex: 'comments',
    //   key: 'comments',
    //   width: '3%',
    // },

    {
      title: 'Action',
      key: 'operation',
      fixed: 'right',
      width: '2%',
      render: (item) => {
        return (
          <div>
            <Space size="middle">
              <EyeOutlined style={{ color: '#0D8616', cursor: 'pointer', fontSize: '20px' }}/>
               <EditOutlined
                  style={{ color: '#0D4B86', cursor: 'pointer', fontSize: '20px' }}
                  // onClick={() => editOrder(item)}
                />
            </Space>
          </div>
        );
      },
    },
  ];
};
